/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Address,
  Contract,
  ContractState,
  TestContractResult,
  HexString,
  ContractFactory,
  EventSubscribeOptions,
  EventSubscription,
  CallContractParams,
  CallContractResult,
  TestContractParams,
  ContractEvent,
  subscribeContractEvent,
  subscribeContractEvents,
  testMethod,
  callMethod,
  multicallMethods,
  fetchContractState,
  Asset,
  ContractInstance,
  getContractEventsCurrentCount,
  TestContractParamsWithoutMaps,
  TestContractResultWithoutMaps,
  SignExecuteContractMethodParams,
  SignExecuteScriptTxResult,
  signExecuteMethod,
  addStdIdToFields,
  encodeContractFields,
  Narrow,
} from "@alephium/web3";
import { default as VoteContractJson } from "../vote/Vote.ral.json";
import { getContractByCodeHash, registerContract } from "./contracts";
import * as types from "./types";

// Custom types for the contract
export namespace VoteTypes {
  export type Fields = {
    iapadStaker: HexString;
    upgradableSettings: types.UpgradableSettings;
  };

  export type State = ContractState<Fields>;

  export type ChangeOwnerCommenceEvent = ContractEvent<{
    owner: Address;
    changeOwner: Address;
  }>;
  export type ChangeOwnerApplyEvent = ContractEvent<{
    owner: Address;
    changeOwner: Address;
  }>;
  export type MigrateCommenceEvent = ContractEvent<{
    owner: Address;
    changeCode: HexString;
  }>;
  export type MigrateApplyEvent = ContractEvent<{
    owner: Address;
    changeCode: HexString;
  }>;
  export type MigrateWithFieldsApplyEvent = ContractEvent<{
    owner: Address;
    changeCode: HexString;
    changeImmFieldsEncoded: HexString;
    changeMutFieldsEncoded: HexString;
  }>;
  export type CastVoteEvent = ContractEvent<{
    user: Address;
    voteOption: boolean;
    votingPower: bigint;
  }>;

  export interface CallMethodTable {
    changeOwner: {
      params: CallContractParams<{ changeOwner: Address }>;
      result: CallContractResult<null>;
    };
    migrate: {
      params: CallContractParams<{ changeCode: HexString }>;
      result: CallContractResult<null>;
    };
    changeOwnerApply: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    migrateApply: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    migrateWithFieldsApply: {
      params: CallContractParams<{
        newImmFieldsEncoded: HexString;
        newMutFieldsEncoded: HexString;
      }>;
      result: CallContractResult<null>;
    };
    resetUpgrade: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    getUpgradeDelay: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<bigint>;
    };
    getOwner: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<Address>;
    };
    getNewOwner: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<Address>;
    };
    getUpgradeCommenced: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<bigint>;
    };
    getNewCode: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<HexString>;
    };
    resetFields: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    assertOnlyOwner: {
      params: CallContractParams<{ caller: Address }>;
      result: CallContractResult<null>;
    };
    assertUpgradeNotPending: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    assertUpgradeDelayElapsed: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    vote: {
      params: CallContractParams<{ voteOption: boolean }>;
      result: CallContractResult<null>;
    };
    getSubAccount: {
      params: CallContractParams<{ caller: Address }>;
      result: CallContractResult<HexString>;
    };
    getStaked: {
      params: CallContractParams<{ subAccount: HexString }>;
      result: CallContractResult<bigint>;
    };
  }
  export type CallMethodParams<T extends keyof CallMethodTable> =
    CallMethodTable[T]["params"];
  export type CallMethodResult<T extends keyof CallMethodTable> =
    CallMethodTable[T]["result"];
  export type MultiCallParams = Partial<{
    [Name in keyof CallMethodTable]: CallMethodTable[Name]["params"];
  }>;
  export type MultiCallResults<T extends MultiCallParams> = {
    [MaybeName in keyof T]: MaybeName extends keyof CallMethodTable
      ? CallMethodTable[MaybeName]["result"]
      : undefined;
  };
  export type MulticallReturnType<Callss extends MultiCallParams[]> = {
    [index in keyof Callss]: MultiCallResults<Callss[index]>;
  };

  export interface SignExecuteMethodTable {
    changeOwner: {
      params: SignExecuteContractMethodParams<{ changeOwner: Address }>;
      result: SignExecuteScriptTxResult;
    };
    migrate: {
      params: SignExecuteContractMethodParams<{ changeCode: HexString }>;
      result: SignExecuteScriptTxResult;
    };
    changeOwnerApply: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    migrateApply: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    migrateWithFieldsApply: {
      params: SignExecuteContractMethodParams<{
        newImmFieldsEncoded: HexString;
        newMutFieldsEncoded: HexString;
      }>;
      result: SignExecuteScriptTxResult;
    };
    resetUpgrade: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    getUpgradeDelay: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    getOwner: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    getNewOwner: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    getUpgradeCommenced: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    getNewCode: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    resetFields: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    assertOnlyOwner: {
      params: SignExecuteContractMethodParams<{ caller: Address }>;
      result: SignExecuteScriptTxResult;
    };
    assertUpgradeNotPending: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    assertUpgradeDelayElapsed: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    vote: {
      params: SignExecuteContractMethodParams<{ voteOption: boolean }>;
      result: SignExecuteScriptTxResult;
    };
    getSubAccount: {
      params: SignExecuteContractMethodParams<{ caller: Address }>;
      result: SignExecuteScriptTxResult;
    };
    getStaked: {
      params: SignExecuteContractMethodParams<{ subAccount: HexString }>;
      result: SignExecuteScriptTxResult;
    };
  }
  export type SignExecuteMethodParams<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["params"];
  export type SignExecuteMethodResult<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["result"];
}

class Factory extends ContractFactory<VoteInstance, VoteTypes.Fields> {
  encodeFields(fields: VoteTypes.Fields) {
    return encodeContractFields(
      addStdIdToFields(this.contract, fields),
      this.contract.fieldsSig,
      types.AllStructs
    );
  }

  eventIndex = {
    ChangeOwnerCommence: 0,
    ChangeOwnerApply: 1,
    MigrateCommence: 2,
    MigrateApply: 3,
    MigrateWithFieldsApply: 4,
    CastVote: 5,
  };
  consts = {
    UpgradeErrorCodes: {
      Forbidden: BigInt("13000"),
      UpgradePending: BigInt("13001"),
      UpgradeNotPending: BigInt("13002"),
      UpgradeDelayNotExpired: BigInt("13003"),
      MigrateNotPending: BigInt("13004"),
      MigrateWithFieldsNotPending: BigInt("13005"),
      ChangeOwnerNotPending: BigInt("13006"),
    },
  };

  at(address: string): VoteInstance {
    return new VoteInstance(address);
  }

  tests = {
    changeOwner: async (
      params: TestContractParamsWithoutMaps<
        VoteTypes.Fields,
        { changeOwner: Address }
      >
    ): Promise<TestContractResultWithoutMaps<null>> => {
      return testMethod(this, "changeOwner", params, getContractByCodeHash);
    },
    migrate: async (
      params: TestContractParamsWithoutMaps<
        VoteTypes.Fields,
        { changeCode: HexString }
      >
    ): Promise<TestContractResultWithoutMaps<null>> => {
      return testMethod(this, "migrate", params, getContractByCodeHash);
    },
    changeOwnerApply: async (
      params: Omit<
        TestContractParamsWithoutMaps<VoteTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<null>> => {
      return testMethod(
        this,
        "changeOwnerApply",
        params,
        getContractByCodeHash
      );
    },
    migrateApply: async (
      params: Omit<
        TestContractParamsWithoutMaps<VoteTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<null>> => {
      return testMethod(this, "migrateApply", params, getContractByCodeHash);
    },
    migrateWithFieldsApply: async (
      params: TestContractParamsWithoutMaps<
        VoteTypes.Fields,
        { newImmFieldsEncoded: HexString; newMutFieldsEncoded: HexString }
      >
    ): Promise<TestContractResultWithoutMaps<null>> => {
      return testMethod(
        this,
        "migrateWithFieldsApply",
        params,
        getContractByCodeHash
      );
    },
    resetUpgrade: async (
      params: Omit<
        TestContractParamsWithoutMaps<VoteTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<null>> => {
      return testMethod(this, "resetUpgrade", params, getContractByCodeHash);
    },
    getUpgradeDelay: async (
      params: Omit<
        TestContractParamsWithoutMaps<VoteTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(this, "getUpgradeDelay", params, getContractByCodeHash);
    },
    getOwner: async (
      params: Omit<
        TestContractParamsWithoutMaps<VoteTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<Address>> => {
      return testMethod(this, "getOwner", params, getContractByCodeHash);
    },
    getNewOwner: async (
      params: Omit<
        TestContractParamsWithoutMaps<VoteTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<Address>> => {
      return testMethod(this, "getNewOwner", params, getContractByCodeHash);
    },
    getUpgradeCommenced: async (
      params: Omit<
        TestContractParamsWithoutMaps<VoteTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(
        this,
        "getUpgradeCommenced",
        params,
        getContractByCodeHash
      );
    },
    getNewCode: async (
      params: Omit<
        TestContractParamsWithoutMaps<VoteTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<HexString>> => {
      return testMethod(this, "getNewCode", params, getContractByCodeHash);
    },
    resetFields: async (
      params: Omit<
        TestContractParamsWithoutMaps<VoteTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<null>> => {
      return testMethod(this, "resetFields", params, getContractByCodeHash);
    },
    assertOnlyOwner: async (
      params: TestContractParamsWithoutMaps<
        VoteTypes.Fields,
        { caller: Address }
      >
    ): Promise<TestContractResultWithoutMaps<null>> => {
      return testMethod(this, "assertOnlyOwner", params, getContractByCodeHash);
    },
    assertUpgradeNotPending: async (
      params: Omit<
        TestContractParamsWithoutMaps<VoteTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<null>> => {
      return testMethod(
        this,
        "assertUpgradeNotPending",
        params,
        getContractByCodeHash
      );
    },
    assertUpgradeDelayElapsed: async (
      params: Omit<
        TestContractParamsWithoutMaps<VoteTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<null>> => {
      return testMethod(
        this,
        "assertUpgradeDelayElapsed",
        params,
        getContractByCodeHash
      );
    },
    vote: async (
      params: TestContractParamsWithoutMaps<
        VoteTypes.Fields,
        { voteOption: boolean }
      >
    ): Promise<TestContractResultWithoutMaps<null>> => {
      return testMethod(this, "vote", params, getContractByCodeHash);
    },
    getSubAccount: async (
      params: TestContractParamsWithoutMaps<
        VoteTypes.Fields,
        { caller: Address }
      >
    ): Promise<TestContractResultWithoutMaps<HexString>> => {
      return testMethod(this, "getSubAccount", params, getContractByCodeHash);
    },
    getStaked: async (
      params: TestContractParamsWithoutMaps<
        VoteTypes.Fields,
        { subAccount: HexString }
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(this, "getStaked", params, getContractByCodeHash);
    },
  };

  stateForTest(initFields: VoteTypes.Fields, asset?: Asset, address?: string) {
    return this.stateForTest_(initFields, asset, address, undefined);
  }
}

// Use this object to test and deploy the contract
export const Vote = new Factory(
  Contract.fromJson(
    VoteContractJson,
    "",
    "85806b92e24ee4162ed986cc37a565dfcb1058bcce9d8ac4349a54f5758442df",
    types.AllStructs
  )
);
registerContract(Vote);

// Use this class to interact with the blockchain
export class VoteInstance extends ContractInstance {
  constructor(address: Address) {
    super(address);
  }

  async fetchState(): Promise<VoteTypes.State> {
    return fetchContractState(Vote, this);
  }

  async getContractEventsCurrentCount(): Promise<number> {
    return getContractEventsCurrentCount(this.address);
  }

  subscribeChangeOwnerCommenceEvent(
    options: EventSubscribeOptions<VoteTypes.ChangeOwnerCommenceEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      Vote.contract,
      this,
      options,
      "ChangeOwnerCommence",
      fromCount
    );
  }

  subscribeChangeOwnerApplyEvent(
    options: EventSubscribeOptions<VoteTypes.ChangeOwnerApplyEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      Vote.contract,
      this,
      options,
      "ChangeOwnerApply",
      fromCount
    );
  }

  subscribeMigrateCommenceEvent(
    options: EventSubscribeOptions<VoteTypes.MigrateCommenceEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      Vote.contract,
      this,
      options,
      "MigrateCommence",
      fromCount
    );
  }

  subscribeMigrateApplyEvent(
    options: EventSubscribeOptions<VoteTypes.MigrateApplyEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      Vote.contract,
      this,
      options,
      "MigrateApply",
      fromCount
    );
  }

  subscribeMigrateWithFieldsApplyEvent(
    options: EventSubscribeOptions<VoteTypes.MigrateWithFieldsApplyEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      Vote.contract,
      this,
      options,
      "MigrateWithFieldsApply",
      fromCount
    );
  }

  subscribeCastVoteEvent(
    options: EventSubscribeOptions<VoteTypes.CastVoteEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      Vote.contract,
      this,
      options,
      "CastVote",
      fromCount
    );
  }

  subscribeAllEvents(
    options: EventSubscribeOptions<
      | VoteTypes.ChangeOwnerCommenceEvent
      | VoteTypes.ChangeOwnerApplyEvent
      | VoteTypes.MigrateCommenceEvent
      | VoteTypes.MigrateApplyEvent
      | VoteTypes.MigrateWithFieldsApplyEvent
      | VoteTypes.CastVoteEvent
    >,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvents(Vote.contract, this, options, fromCount);
  }

  view = {
    changeOwner: async (
      params: VoteTypes.CallMethodParams<"changeOwner">
    ): Promise<VoteTypes.CallMethodResult<"changeOwner">> => {
      return callMethod(
        Vote,
        this,
        "changeOwner",
        params,
        getContractByCodeHash
      );
    },
    migrate: async (
      params: VoteTypes.CallMethodParams<"migrate">
    ): Promise<VoteTypes.CallMethodResult<"migrate">> => {
      return callMethod(Vote, this, "migrate", params, getContractByCodeHash);
    },
    changeOwnerApply: async (
      params?: VoteTypes.CallMethodParams<"changeOwnerApply">
    ): Promise<VoteTypes.CallMethodResult<"changeOwnerApply">> => {
      return callMethod(
        Vote,
        this,
        "changeOwnerApply",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    migrateApply: async (
      params?: VoteTypes.CallMethodParams<"migrateApply">
    ): Promise<VoteTypes.CallMethodResult<"migrateApply">> => {
      return callMethod(
        Vote,
        this,
        "migrateApply",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    migrateWithFieldsApply: async (
      params: VoteTypes.CallMethodParams<"migrateWithFieldsApply">
    ): Promise<VoteTypes.CallMethodResult<"migrateWithFieldsApply">> => {
      return callMethod(
        Vote,
        this,
        "migrateWithFieldsApply",
        params,
        getContractByCodeHash
      );
    },
    resetUpgrade: async (
      params?: VoteTypes.CallMethodParams<"resetUpgrade">
    ): Promise<VoteTypes.CallMethodResult<"resetUpgrade">> => {
      return callMethod(
        Vote,
        this,
        "resetUpgrade",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    getUpgradeDelay: async (
      params?: VoteTypes.CallMethodParams<"getUpgradeDelay">
    ): Promise<VoteTypes.CallMethodResult<"getUpgradeDelay">> => {
      return callMethod(
        Vote,
        this,
        "getUpgradeDelay",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    getOwner: async (
      params?: VoteTypes.CallMethodParams<"getOwner">
    ): Promise<VoteTypes.CallMethodResult<"getOwner">> => {
      return callMethod(
        Vote,
        this,
        "getOwner",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    getNewOwner: async (
      params?: VoteTypes.CallMethodParams<"getNewOwner">
    ): Promise<VoteTypes.CallMethodResult<"getNewOwner">> => {
      return callMethod(
        Vote,
        this,
        "getNewOwner",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    getUpgradeCommenced: async (
      params?: VoteTypes.CallMethodParams<"getUpgradeCommenced">
    ): Promise<VoteTypes.CallMethodResult<"getUpgradeCommenced">> => {
      return callMethod(
        Vote,
        this,
        "getUpgradeCommenced",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    getNewCode: async (
      params?: VoteTypes.CallMethodParams<"getNewCode">
    ): Promise<VoteTypes.CallMethodResult<"getNewCode">> => {
      return callMethod(
        Vote,
        this,
        "getNewCode",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    resetFields: async (
      params?: VoteTypes.CallMethodParams<"resetFields">
    ): Promise<VoteTypes.CallMethodResult<"resetFields">> => {
      return callMethod(
        Vote,
        this,
        "resetFields",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    assertOnlyOwner: async (
      params: VoteTypes.CallMethodParams<"assertOnlyOwner">
    ): Promise<VoteTypes.CallMethodResult<"assertOnlyOwner">> => {
      return callMethod(
        Vote,
        this,
        "assertOnlyOwner",
        params,
        getContractByCodeHash
      );
    },
    assertUpgradeNotPending: async (
      params?: VoteTypes.CallMethodParams<"assertUpgradeNotPending">
    ): Promise<VoteTypes.CallMethodResult<"assertUpgradeNotPending">> => {
      return callMethod(
        Vote,
        this,
        "assertUpgradeNotPending",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    assertUpgradeDelayElapsed: async (
      params?: VoteTypes.CallMethodParams<"assertUpgradeDelayElapsed">
    ): Promise<VoteTypes.CallMethodResult<"assertUpgradeDelayElapsed">> => {
      return callMethod(
        Vote,
        this,
        "assertUpgradeDelayElapsed",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    vote: async (
      params: VoteTypes.CallMethodParams<"vote">
    ): Promise<VoteTypes.CallMethodResult<"vote">> => {
      return callMethod(Vote, this, "vote", params, getContractByCodeHash);
    },
    getSubAccount: async (
      params: VoteTypes.CallMethodParams<"getSubAccount">
    ): Promise<VoteTypes.CallMethodResult<"getSubAccount">> => {
      return callMethod(
        Vote,
        this,
        "getSubAccount",
        params,
        getContractByCodeHash
      );
    },
    getStaked: async (
      params: VoteTypes.CallMethodParams<"getStaked">
    ): Promise<VoteTypes.CallMethodResult<"getStaked">> => {
      return callMethod(Vote, this, "getStaked", params, getContractByCodeHash);
    },
  };

  transact = {
    changeOwner: async (
      params: VoteTypes.SignExecuteMethodParams<"changeOwner">
    ): Promise<VoteTypes.SignExecuteMethodResult<"changeOwner">> => {
      return signExecuteMethod(Vote, this, "changeOwner", params);
    },
    migrate: async (
      params: VoteTypes.SignExecuteMethodParams<"migrate">
    ): Promise<VoteTypes.SignExecuteMethodResult<"migrate">> => {
      return signExecuteMethod(Vote, this, "migrate", params);
    },
    changeOwnerApply: async (
      params: VoteTypes.SignExecuteMethodParams<"changeOwnerApply">
    ): Promise<VoteTypes.SignExecuteMethodResult<"changeOwnerApply">> => {
      return signExecuteMethod(Vote, this, "changeOwnerApply", params);
    },
    migrateApply: async (
      params: VoteTypes.SignExecuteMethodParams<"migrateApply">
    ): Promise<VoteTypes.SignExecuteMethodResult<"migrateApply">> => {
      return signExecuteMethod(Vote, this, "migrateApply", params);
    },
    migrateWithFieldsApply: async (
      params: VoteTypes.SignExecuteMethodParams<"migrateWithFieldsApply">
    ): Promise<VoteTypes.SignExecuteMethodResult<"migrateWithFieldsApply">> => {
      return signExecuteMethod(Vote, this, "migrateWithFieldsApply", params);
    },
    resetUpgrade: async (
      params: VoteTypes.SignExecuteMethodParams<"resetUpgrade">
    ): Promise<VoteTypes.SignExecuteMethodResult<"resetUpgrade">> => {
      return signExecuteMethod(Vote, this, "resetUpgrade", params);
    },
    getUpgradeDelay: async (
      params: VoteTypes.SignExecuteMethodParams<"getUpgradeDelay">
    ): Promise<VoteTypes.SignExecuteMethodResult<"getUpgradeDelay">> => {
      return signExecuteMethod(Vote, this, "getUpgradeDelay", params);
    },
    getOwner: async (
      params: VoteTypes.SignExecuteMethodParams<"getOwner">
    ): Promise<VoteTypes.SignExecuteMethodResult<"getOwner">> => {
      return signExecuteMethod(Vote, this, "getOwner", params);
    },
    getNewOwner: async (
      params: VoteTypes.SignExecuteMethodParams<"getNewOwner">
    ): Promise<VoteTypes.SignExecuteMethodResult<"getNewOwner">> => {
      return signExecuteMethod(Vote, this, "getNewOwner", params);
    },
    getUpgradeCommenced: async (
      params: VoteTypes.SignExecuteMethodParams<"getUpgradeCommenced">
    ): Promise<VoteTypes.SignExecuteMethodResult<"getUpgradeCommenced">> => {
      return signExecuteMethod(Vote, this, "getUpgradeCommenced", params);
    },
    getNewCode: async (
      params: VoteTypes.SignExecuteMethodParams<"getNewCode">
    ): Promise<VoteTypes.SignExecuteMethodResult<"getNewCode">> => {
      return signExecuteMethod(Vote, this, "getNewCode", params);
    },
    resetFields: async (
      params: VoteTypes.SignExecuteMethodParams<"resetFields">
    ): Promise<VoteTypes.SignExecuteMethodResult<"resetFields">> => {
      return signExecuteMethod(Vote, this, "resetFields", params);
    },
    assertOnlyOwner: async (
      params: VoteTypes.SignExecuteMethodParams<"assertOnlyOwner">
    ): Promise<VoteTypes.SignExecuteMethodResult<"assertOnlyOwner">> => {
      return signExecuteMethod(Vote, this, "assertOnlyOwner", params);
    },
    assertUpgradeNotPending: async (
      params: VoteTypes.SignExecuteMethodParams<"assertUpgradeNotPending">
    ): Promise<
      VoteTypes.SignExecuteMethodResult<"assertUpgradeNotPending">
    > => {
      return signExecuteMethod(Vote, this, "assertUpgradeNotPending", params);
    },
    assertUpgradeDelayElapsed: async (
      params: VoteTypes.SignExecuteMethodParams<"assertUpgradeDelayElapsed">
    ): Promise<
      VoteTypes.SignExecuteMethodResult<"assertUpgradeDelayElapsed">
    > => {
      return signExecuteMethod(Vote, this, "assertUpgradeDelayElapsed", params);
    },
    vote: async (
      params: VoteTypes.SignExecuteMethodParams<"vote">
    ): Promise<VoteTypes.SignExecuteMethodResult<"vote">> => {
      return signExecuteMethod(Vote, this, "vote", params);
    },
    getSubAccount: async (
      params: VoteTypes.SignExecuteMethodParams<"getSubAccount">
    ): Promise<VoteTypes.SignExecuteMethodResult<"getSubAccount">> => {
      return signExecuteMethod(Vote, this, "getSubAccount", params);
    },
    getStaked: async (
      params: VoteTypes.SignExecuteMethodParams<"getStaked">
    ): Promise<VoteTypes.SignExecuteMethodResult<"getStaked">> => {
      return signExecuteMethod(Vote, this, "getStaked", params);
    },
  };

  async multicall<Calls extends VoteTypes.MultiCallParams>(
    calls: Calls
  ): Promise<VoteTypes.MultiCallResults<Calls>>;
  async multicall<Callss extends VoteTypes.MultiCallParams[]>(
    callss: Narrow<Callss>
  ): Promise<VoteTypes.MulticallReturnType<Callss>>;
  async multicall<
    Callss extends VoteTypes.MultiCallParams | VoteTypes.MultiCallParams[]
  >(callss: Callss): Promise<unknown> {
    return await multicallMethods(Vote, this, callss, getContractByCodeHash);
  }
}
